module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.groupType + '-group', _vm.getTheme]
  }, [(_vm.$slots.title) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._t("title")], 2) : (_vm.title) ? _c('label', {
    attrs: {
      "for": _vm.vaId
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.$slots.slotPrefixButton) ? _c('div', {
    staticClass: "input-group-btn"
  }, [_vm._t("slotPrefixButton"), _vm._v(" "), _vm._t("slotPrefixDropdown")], 2) : _vm._e(), _vm._v(" "), (_vm.prefixAddonText || _vm.$slots.slotPrefixAddonText) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n    " + _vm._s(_vm.prefixAddonText) + "\n    "), _vm._t("slotPrefixAddonText")], 2) : _vm._e(), _vm._v(" "), _c('va-input', {
    attrs: {
      "type": _vm.type,
      "vaId": _vm.vaId,
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "value": _vm.value,
      "isFormControl": _vm.type != 'file',
      "isDisabled": _vm.isDisabled
    }
  }), _vm._v(" "), (_vm.suffixAddonText || _vm.$slots.slotSuffixAddonText) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n    " + _vm._s(_vm.suffixAddonText) + "\n    "), _vm._t("slotSuffixAddonText")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.slotSuffixButton) ? _c('div', {
    staticClass: "input-group-btn"
  }, [_vm._t("slotSuffixButton"), _vm._v(" "), _vm._t("slotSuffixDropdown")], 2) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpBlock),
      expression: "helpBlock"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.helpBlock))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cee596a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAInputGroup.vue
// module id = 497
// module chunks = 1